import { Component } from '@angular/core';
import { CellRendererComponent } from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { Column } from '@valg-shared/components/table/table/column';
import NumberFormatService from '@valg-shared/services/number-format-service/number-format.service';
@Component({
  selector: 'valg-dk-positive-negative-renderer',
  templateUrl: './positive-negative-renderer.component.html'
})
export class PositiveNegativeRendererComponent implements CellRendererComponent {
  value = 0;
  text = ""
  showColors = false;

  constructor(protected readonly numberFormatService: NumberFormatService){

  }

  public init(data: unknown, column: Column): void {
    this.value = getValueAt(data, column.path);
      if(this.value == null) {
        this.text = column.metadata?.defaultValueIfNull ?? '';
      } else if(this.value !== undefined){
      if(this.formatPercentage(column)){
        this.text = this.numberFormatService.formatPercentage(this.value);
        if(this.value > 0){
          this.text = '+'+this.text;
          this.showColors = this.getShowColor(column);
        }
        else if(this.value == 0)
        {
          this.showColors = false;
        }
        else
        {
          this.showColors = this.getShowColor(column);
        }
      } else{
        this.text = this.value.toString();
      }
    }
  }

  formatPercentage(column: Column): boolean {
    let type = column.metadata?.rendererOptions?.get('asPercentage');
    
    return type ? <boolean>type : false;
  }

  getShowColor(column: Column): boolean{
    let showColors = column.metadata?.rendererOptions?.get('showColors');
    return showColors === true ? true : false;
  }
  
  isPositive(value: number): boolean{
    return value > 0;
  }

}
